import { createAction, handleActions } from "redux-actions"
import produce from "immer";

import { callEoForSendWhisperAction, callEoForSendGroupChatAction, callEoForSendAction } from "../lib/EoBrowserSendUtil";
import { ctRcvKind, ctBubbleKind } from "../lib/classTalk/CodeEnum";

// ======================================================================================================== //

export const GROUPCHAT_STATE_INIT           = "groupChat/GROUPCHAT_STATE_INIT";

const INIT_GROUP_CHAT                       = "groupChat/INIT_GROUP_CHAT";
const INIT_GROUP_CHAT_POPUP                 = "groupChat/INIT_GROUP_CHAT_POPUP";

const OPEN_GROUP_CHAT_POPUP                 = "groupChat/OPEN_GROUP_CHAT_POPUP";
const CLOSE_GROUP_CHAT_POPUP                = "groupChat/CLOSE_GROUP_CHAT_POPUP";

const GROUP_CHAT_INIT                       = "groupChat/GROUP_CHAT_INIT";
const SEND_GROUP_CHAT_INIT_DATA             = "groupChat/SEND_GROUP_CHAT_INIT_DATA";

const OPEN_PERSONAL_CHAT_POPUP              = "groupChat/OPEN_PERSONAL_CHAT_POPUP";
const SEND_WHISPER_INIT_DATA                = "groupChat/SEND_WHISPER_INIT_DATA";
const RECEIVE_WHISPER_MESSAGE               = "groupChat/RECEIVE_WHISPER_MESSAGE";
const UPDATE_CONTENT_SEND_STATUS            = "groupChat/UPDATE_CONTENT_SEND_STATUS";

const SEND_GROUP_CHAT_HISTORY               = "groupChat/SEND_GROUP_CHAT_HISTORY";

export const CHANGE_MEMBER_NICKNAME         = "groupChat/CHANGE_MEMBER_NICKNAME";
export const CHANGE_MEMBER_STATUS_JOIN      = "groupChat/CHANGE_MEMBER_STATUS_JOIN";
export const CHANGE_MEMBER_STATUS_EXIT      = "groupChat/CHANGE_MEMBER_STATUS_EXIT";

// ======================================================================================================== //

//export const initGroupChat                  = createAction(GROUPCHAT_INIT);
export const initGroupChat                  = createAction(INIT_GROUP_CHAT);
export const initGroupChatPopup             = createAction(INIT_GROUP_CHAT_POPUP);
export const clearGroupChat                 = createAction(GROUPCHAT_STATE_INIT);

export const openGroupChatPopup             = createAction(OPEN_GROUP_CHAT_POPUP);
export const closeGroupChatPopup            = createAction(CLOSE_GROUP_CHAT_POPUP);

export const groupChatPopupInitialize       = createAction(GROUP_CHAT_INIT);
export const sendGroupChatInitData          = createAction(SEND_GROUP_CHAT_INIT_DATA);

export const openPersonalChat               = createAction(OPEN_PERSONAL_CHAT_POPUP);
export const sendWhisperInitData            = createAction(SEND_WHISPER_INIT_DATA);
export const appendReceiveWhisperMessage    = createAction(RECEIVE_WHISPER_MESSAGE);
export const updateContentSendStatusAtGroup = createAction(UPDATE_CONTENT_SEND_STATUS);

export const sendGroupChatHistory           = createAction(SEND_GROUP_CHAT_HISTORY);

export const changeMemberNickname           = createAction(CHANGE_MEMBER_NICKNAME);

// ======================================================================================================== //

const initialState = {
    liveSeq         : -1,
    list_groupChat  : []
}

const groupChat = handleActions({
    [GROUPCHAT_STATE_INIT]: (state, action) => {
        console.log("GROUPCHAT_STATE_INIT");
        
        return {
            ...state,
            liveSeq: -1,
            list_groupChat: []
        }
    },

    /**
     * 실행: PentalkBrowser
     * 클래스 ON 되면 list_groupChat 초기값 설정
     */
    [INIT_GROUP_CHAT]: (state, action) => {
        console.log("INIT_GROUP_CHAT - ", action.payload);
        const { liveSeq, list_member } = action.payload;

        let list_chat = list_member.map(member => ({
            userSeq: member.userSeq,
            userNickname: member.userNickname,
            profileImg: member.userProfileImg,
            userJoinStatus: member.userJoinStatus,
            chat_history: []
        }));

        return {
            ...state,
            liveSeq,
            list_groupChat: list_chat
        }
    },

    /**
     * 실행: GroupChatBrowser
     * GroupChatBrowser 초기 값 설정 부분
     */
    [INIT_GROUP_CHAT_POPUP]: (state, action) => {
        console.log("INIT_GROUP_CHAT_POPUP - ", action.payload);

        const { liveSeq, list_groupChat } = action.payload;

        console.log("state values) ", state.liveSeq, state.list_groupChat);

        return {
            ...state, 
            liveSeq,
            list_groupChat
        }
    },

    /** 
     * 실행: PentalkBrowser
     * PentalkBrowser에서 GroupChatBrowser를 열기 위해 action 전송하는 부분
     */
    [OPEN_GROUP_CHAT_POPUP]: (state, action) => {
        console.log("OPEN_GROUP_CHAT_POPUP");

        callEoForSendGroupChatAction("openGroupChatPopup", state.liveSeq);

        return {
            ...state
        }
    },
    
    /** 
     * 실행: PentalkBrowser
     * PentalkBrowser에서 GroupChatBrowser를 닫기 위해 action 전송하는 부분
     */
    [CLOSE_GROUP_CHAT_POPUP]: (state, action) => {
        console.log("CLOSE_GROUP_CHAT_POPUP");
        callEoForSendGroupChatAction("closeGroupChatPopup");

        return {
            ...state,
        }
    },
    
    /** 
     * 실행: GroupChatBrowser
     * GroupChatBrowser를 열 때, 데이터를 전달받기 위해 PentalkBrowser에게 요청하는 부분
     */
    [GROUP_CHAT_INIT]: (state, action) => {
        console.log("GROUP_CHAT_INIT (call InitDone)");
        callEoForSendGroupChatAction("initDone");

        return {
            ...state,
        }
    },

    /**
     * 실행: PentalkBrowser
     * GroupChatBrowser로부터 initDone을 받았을 때, list_groupChat 데이터를 전송함 
     */
    [SEND_GROUP_CHAT_INIT_DATA]: (state, action) => {
        console.log("SEND_GROUP_CHAT_INIT_DATA - ");

        callEoForSendGroupChatAction("sendInitData", "", { kind: "groupChat-popup", data: { kind: "sendInitData", data: { liveSeq: state.liveSeq, list_groupChat: state.list_groupChat } }});

        return {
            ...state
        }
    },
    
    /**
     * 실행: GroupChatBrowser
     * WhisperBrowser를 열기 위해 action 전송하는 부분
     */
    [OPEN_PERSONAL_CHAT_POPUP]: (state, action) => {
        const { memberSeqList } = action.payload;
        console.log("OPEN_PERSONAL_CHAT_POPUP - ", action.payload);

        if (memberSeqList && memberSeqList.length > 0) {
            callEoForSendWhisperAction("openWhisperPopup", memberSeqList.map(info => info.userSeq));
        }

        return {
            ...state,
        }
    },

    /**
     * 실행: PentalkBrowser
     * WhisperBrowser를 열 때, 데이터를 전송하는 부분
     */
    [SEND_WHISPER_INIT_DATA]: (state, action) => {
        const { stdSeq, userInfo } = action.payload;
        console.log("SEND_WHISPER_INIT_DATA - ", action.payload);

        let whisper_info = state.list_groupChat.find(info => info.userSeq === stdSeq);
        
        if (whisper_info) {
            callEoForSendWhisperAction("sendInitData", stdSeq, { kind:"whisper-popup", data: { kind: "sendInitData", data: { data: whisper_info, userInfo } }});
        }
        
        return {
            ...state
        }
    },
    
    /**
     * 발신: WhisperBrowser
     * 수신: GroupChatBrowser
     * WhisperBrowser에서 보낸 채팅 메시지를 GroupChatBrowser의 list_groupChat에 추가
     */
    [RECEIVE_WHISPER_MESSAGE]: (state, action) => {
        const { kind, stdSeq, msgInfo, content } = action.payload;
        console.log("RECEIVE_WHISPER_MESSAGE - ", action.payload);

        return produce (state, draft => {
            const whisper_info = draft.list_groupChat.find(info => info.userSeq === Number(stdSeq));
            
            if (kind === "whisper-intensiveControl") {                
                const { action: contentAction, information, userNickname, receiveStudentSeq } = content;
                
                let newMsgInfo = {
                    kind: ctBubbleKind.SendMsg,
                    msgInfo: {
                        rcvKind: ctRcvKind.ContentSend,
                        action: contentAction,    // "url-start" | "app-start" | "file-start" | "message-start"
                        information,              // { url, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq, ... } 원본 구조 그대로
                        userNickname,
                        // receiveStudentSeq: seq 배열 → 상세 객체 배열로 변환해서 저장
                        // 이후 UPDATE_CONTENT_SEND_STATUS에서 각 항목의 status/isReceived 갱신
                        receiveStudentSeq: receiveStudentSeq.map(m => ({
                            userSeq     : String(m.userSeq),
                            userNickname: m.userNickname,
                            isReceived  : false,    // 수신 확인 전
                            status      : null,     // "received" | "executed" | "not_installed" | "downloaded" | "not_support" | "permission_denied" | "invalid_payload"
                        })),
                    }
                };
                
                whisper_info.chat_history.push(newMsgInfo);
            } else {
                let newMsgInfo = {
                    kind,
                    msgInfo
                };

                whisper_info.chat_history.push(newMsgInfo);
            }
        });
    },
        
    [UPDATE_CONTENT_SEND_STATUS]: (state, action) => {
        const { contentSeq, userSeq, status } = action.payload;
        console.log("UPDATE_CONTENT_SEND_STATUS - payload => ", action.payload);
        // contentSeq: 어떤 전송 건인지 식별
        // userSeq: 누가 수신 확인했는지

        console.log("list_groupChat: ", state.list_groupChat);

        return produce(state, draft => {
            // groupChat state에는 whisper_info가 없고, list_groupChat의 각 멤버별 chat_history에 흩어져 있으므로 전체 순회
            for (const whisperInfo of draft.list_groupChat) {
                const targetMsg = whisperInfo.chat_history.find(
                    msg =>
                        msg.kind === ctBubbleKind.SendMsg &&
                        msg.msgInfo.rcvKind === ctRcvKind.ContentSend &&
                        // ✅ APPEND_SEND_CONTENT에서 contentSeq는 information 안에 저장됨
                        // msgInfo.contentSeq (X) → msgInfo.information.contentSeq (O)
                        msg.msgInfo.information?.contentSeq === contentSeq
                );

                if (targetMsg) {
                    console.log("targetMsg exist!!!");
                    // receiveStudentSeq 배열에서 해당 학생 항목 갱신
                    const member = targetMsg.msgInfo.receiveStudentSeq.find(
                        m => String(m.userSeq) === String(userSeq)
                    );

                    console.log("member -- ", userSeq, member);

                    if (member) {
                        // member.isReceived = status === "received"; // "not_support" 또는 "permission_denied"이면 isReceived = false, "received"이면 isReceived = true
                        member.isReceived = status !== null; // null이면 isReceived = false, 그 외의 경우 isReceived = true ("received" | "executed" | "not_installed" | "downloaded" | "not_support" | "permission_denied" | "invalid_payload")
                        member.status = status;
                        console.log("member status is ", status);
                    }
                    break; // 대상을 찾았으면 나머지 멤버는 순회할 필요 없음
                }
            }
        });
    },

    /** 
     * 실행: PentalkBrowser
     * Pro 학생 / Group이 로그인 한 경우, 저장된 list_groupChat 데이터를 전송
     */
    [SEND_GROUP_CHAT_HISTORY]: (state, action) => {
        console.log("SEND_GROUP_CHAT_HISTORY - ", action.payload);

        const { userSeq, user_info } = action.payload;

        const groupChatList = state.list_groupChat.find(info => info.userSeq === userSeq);
        if (groupChatList) {
            // 260819: etcData를 ""(전체 브로드캐스트)로 보내던 것을, 재접속한 학생(userSeq) 1명에게만
            // 라우팅되도록 수정. 안 그러면 RBMQ 라우팅키가 접미사 없이 발행돼 다른 학생도 이 그룹챗
            // 이력을 같이 받아버리는 문제가 있었음 ... by Easy
            callEoForSendAction("groupChat", {
                kind    : "pbl",
                action  : "groupChatList",
                information: { list_groupChat: groupChatList.chat_history },
                userNickname: user_info.userNickname
            }, JSON.stringify([userSeq]));
        }

        return {
            ...state
        }
    },

    /**
     * 실행: PentalkBrowser & GroupChatBrowser
     * 멤버가 닉네임 변경하고 들어온 경우, 상태 반영
     */
    [CHANGE_MEMBER_NICKNAME]: (state, action) => {
        console.log("CHANGE_MEMBER_NICKNAME - ", action.payload);

        const { user_info } = action.payload;

        return produce (state, draft => {
            if (user_info.liveSeq !== state.liveSeq) return;

            const userInfo = draft.list_groupChat.find(info => info.userSeq === user_info.userSeq);
            if (userInfo) {
                userInfo.userNickname = user_info.userNickname;
            }
        });
    },

    /**
     * 실행: GroupChatBrowser
     * 멤버가 Join 한 경우, 상태 반영
     */
    [CHANGE_MEMBER_STATUS_JOIN]: (state, action) => {
        console.log("CHANGE_MEMBER_STATUS_JOIN - ", action.payload);

        const { userSeq } = action.payload;

        return produce(state, draft => {
            const userInfo = draft.list_groupChat.find(info => info.userSeq === userSeq);

            if (userInfo) {
                userInfo.userJoinStatus = "Y";
            }
        });
    },

    [CHANGE_MEMBER_STATUS_EXIT]: (state, action) => {
        console.log("CHANGE_MEMBER_STATUS_EXIT - ", action.payload);

        const { userSeq } = action.payload;

        return produce(state, draft => {
            const userInfo = draft.list_groupChat.find(info => info.userSeq === userSeq);

            if (userInfo) {
                userInfo.userJoinStatus = "N";
            }
        });
    }
}, initialState);

export default groupChat;